__turbopack_context__.v({
  "container": "gLbtMq_container",
  "grid": "gLbtMq_grid",
  "headlineNumber": "gLbtMq_headlineNumber",
});
